module.exports = __webpack_public_path__ + "img/list-example.b1b362a.png";